








































import Vue from "vue";
// @ts-ignore
import { VContainer, VRow, VCard, VCardText, VCol, VBtn, VIcon } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { castComponent } from "@/lib/helpers";

Vue.component("VContainer", castComponent(VContainer));
Vue.component("VRow", castComponent(VRow));
Vue.component("VCard", castComponent(VCard));
Vue.component("VCardText", castComponent(VCardText));
Vue.component("VCol", castComponent(VCol));
Vue.component("VBtn", castComponent(VBtn));
Vue.component("VIcon", castComponent(VIcon));

export default defineComponent({
  name: "BlockBase",
  props: {
    title: { type: String },
    button: { type: Boolean, default: false },
    editing: { type: Boolean, default: false },
    cardClass: null,
  },
});
